module.exports = __webpack_public_path__ + "img/gywm-4.257234ea.jpg";